/* eslint-disable react/jsx-props-no-spreading */
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Button, FormHelperText, IconButton, Stack } from '@mui/material';
import { get } from 'lodash-es';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import TextField from './TextField';

interface TextFieldArrayProps {
  [key: string]: any;

  disabled?: boolean;
  name: string;
  label: string;
}

function TextFieldArray({ name, label, disabled = false, ...rest }: TextFieldArrayProps) {
  const { formState } = useFormContext<object>();
  const { fields, append, remove } = useFieldArray({ name });
  const error = get(formState.errors, name);
  return (
    <Stack spacing={2}>
      {error && <FormHelperText error>{error.message}</FormHelperText>}
      {fields.map((field, index) => (
        <Stack key={field.id} direction="row" alignItems="center" spacing={1} sx={{ alignSelf: 'stretch' }}>
          <TextField name={`${name}.${index}.value` as const} label={label} fullWidth disabled={disabled} {...rest} />
          <IconButton onClick={() => remove(index)} aria-label={`Delete ${label}`} disabled={disabled}>
            <DeleteOutlinedIcon />
          </IconButton>
        </Stack>
      ))}
      <Stack direction="row">
        <Button
          variant="text"
          size="small"
          disabled={disabled}
          onClick={() => append({ value: '' }, { shouldFocus: true })}
        >
          {`Add ${label}`}
        </Button>
      </Stack>
    </Stack>
  );
}

export default TextFieldArray;
